/*
 * KH invoice request ("Искам фактура") — cart attributes.
 * Works in the Upcart drawer (shadow DOM) and on the theme /cart page.
 * Data lives in Shopify cart attributes (/cart/update.js) so it reaches the order
 * under "Additional details". No innerHTML, no inline handlers.
 */
(function () {
  'use strict';
  if (window.__khInvoice) { return; }
  window.__khInvoice = true;

  var KEYS = {
    flag: 'Фактура',
    company: 'Фирма',
    eik: 'ЕИК',
    vat: 'ДДС №',
    mol: 'МОЛ',
    address: 'Адрес на регистрация',
    email: 'E-mail за фактура'
  };

  var FIELDS = [
    { id: 'company', label: 'Фирма', required: true, type: 'text', autocomplete: 'organization' },
    { id: 'eik', label: 'ЕИК', required: true, type: 'text', inputmode: 'numeric', autocomplete: 'off' },
    { id: 'vat', label: 'ДДС №', required: false, type: 'text', autocomplete: 'off' },
    { id: 'mol', label: 'МОЛ', required: true, type: 'text', autocomplete: 'name' },
    { id: 'address', label: 'Адрес на регистрация', required: true, type: 'text', autocomplete: 'street-address' },
    { id: 'email', label: 'E-mail за фактура', required: false, type: 'email', autocomplete: 'email' }
  ];

  var MSG_REQUIRED = 'Попълнете полето';
  var MSG_EIK = 'ЕИК трябва да е 9 или 13 цифри';
  var MSG_EMAIL = 'Невалиден e-mail адрес';

  var CSS = [
    '.kh-inv{box-sizing:border-box;margin:16px 0;padding:8px 16px 12px;border:1px solid #e3e3e3;border-radius:8px;font-family:inherit;font-size:14px;line-height:1.4;color:inherit;background:#fff;text-align:left}',
    '.kh-inv *{box-sizing:border-box}',
    '.kh-inv [hidden]{display:none!important}',
    '.kh-inv .kh-inv__toggle{display:flex;align-items:center;gap:10px;min-height:44px;margin:0;font-weight:600;cursor:pointer}',
    '.kh-inv .kh-inv__check{-webkit-appearance:checkbox;appearance:auto;position:static;opacity:1;width:20px;height:20px;margin:0;flex:none;accent-color:#7ca35b;cursor:pointer}',
    '.kh-inv .kh-inv__fields{display:grid;gap:12px;padding-top:6px}',
    '.kh-inv .kh-inv__label{display:block;margin:0 0 4px;font-size:13px;font-weight:600}',
    '.kh-inv .kh-inv__opt{font-weight:400;opacity:.65}',
    '.kh-inv .kh-inv__input{display:block;width:100%;min-height:44px;margin:0;padding:8px 12px;border:1px solid #bdbdbd;border-radius:6px;background:#fff;color:#222;font:inherit;font-size:16px}',
    '.kh-inv .kh-inv__input:focus{outline:2px solid #7ca35b;outline-offset:1px;border-color:#7ca35b}',
    '.kh-inv .kh-inv__input[aria-invalid="true"]{border-color:#c0392b}',
    '.kh-inv .kh-inv__err{margin:4px 0 0;color:#c0392b;font-size:12.5px}',
    '.kh-inv .kh-inv__note{margin:0 0 6px;font-size:13px;line-height:1.4;opacity:.75}'
  ].join('\n');

  var CHECKOUT_SEL = [
    '[name="checkout"]',
    '.mw-btn-modal',
    'a[href$="/checkout"]',
    'a[href$="checkout"]',
    '.upcart-checkout-button-container button',
    '.upcart-checkout-button-container a',
    '.cart__submit'
  ].join(',');

  var state = { on: false, v: {} };
  FIELDS.forEach(function (f) { state.v[f.id] = ''; });

  var instances = [];
  var uid = 0;
  var dirty = false;
  var saveTimer = null;
  var chain = Promise.resolve();
  var lastFetch = 0;
  var bypass = false;
  var observed = typeof WeakSet === 'function' ? new WeakSet() : null;

  /* ---------- state <-> cart attributes ---------- */

  function attrsFromState() {
    var a = {};
    a[KEYS.flag] = state.on ? 'Да' : '';
    FIELDS.forEach(function (f) {
      a[KEYS[f.id]] = state.on ? String(state.v[f.id] || '').trim() : '';
    });
    return a;
  }

  function stateFromAttrs(attrs) {
    attrs = attrs || {};
    state.on = attrs[KEYS.flag] === 'Да';
    FIELDS.forEach(function (f) {
      state.v[f.id] = attrs[KEYS[f.id]] ? String(attrs[KEYS[f.id]]) : '';
    });
  }

  function send() {
    var body = JSON.stringify({ attributes: attrsFromState() });
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }).then(function (r) { return r.json(); }).catch(function () { return null; });
  }

  function flush() {
    if (saveTimer) { clearTimeout(saveTimer); saveTimer = null; }
    if (!dirty) { return chain; }
    dirty = false;
    chain = chain.then(send);
    return chain;
  }

  function scheduleSave() {
    dirty = true;
    if (saveTimer) { clearTimeout(saveTimer); }
    saveTimer = setTimeout(flush, 400);
  }

  function refreshFromServer() {
    if (dirty || saveTimer) { return; }
    var now = Date.now();
    if (now - lastFetch < 2000) { return; }
    lastFetch = now;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (dirty || saveTimer) { return; }
        stateFromAttrs(cart && cart.attributes);
        syncAll();
      })
      .catch(function () {});
  }

  /* ---------- validation ---------- */

  function fieldError(f) {
    var val = String(state.v[f.id] || '').trim();
    if (f.required && !val) { return MSG_REQUIRED; }
    if (f.id === 'eik' && val && !/^(\d{9}|\d{13})$/.test(val)) { return MSG_EIK; }
    if (f.id === 'email' && val && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { return MSG_EMAIL; }
    return '';
  }

  function allErrors() {
    var out = {};
    FIELDS.forEach(function (f) {
      var e = fieldError(f);
      if (e) { out[f.id] = e; }
    });
    return out;
  }

  /* ---------- UI ---------- */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) { n.className = cls; }
    if (text) { n.textContent = text; }
    return n;
  }

  function showError(inst, id, msg) {
    var c = inst.fields[id];
    c.err.textContent = msg || '';
    c.err.hidden = !msg;
    if (msg) { c.input.setAttribute('aria-invalid', 'true'); }
    else { c.input.removeAttribute('aria-invalid'); }
  }

  function build() {
    var n = ++uid;
    var root = el('div', 'kh-inv');
    root.setAttribute('data-kh-invoice', '');

    var toggle = el('label', 'kh-inv__toggle');
    var check = el('input', 'kh-inv__check');
    check.type = 'checkbox';
    check.id = 'kh-inv-check-' + n;
    toggle.setAttribute('for', check.id);
    toggle.appendChild(check);
    toggle.appendChild(el('span', '', 'Искам фактура'));
    root.appendChild(toggle);

    /* info line (2026-10-20, Ivelin): free delivery for companies, text only, no shipping logic.
       Text comes from the locale key kh_invoice.b2b_shipping, set by layout/theme.liquid. */
    var note = (window.KH_INV_T && window.KH_INV_T.b2b_shipping) || '';
    if (note) { root.appendChild(el('p', 'kh-inv__note', note)); }

    var wrap = el('div', 'kh-inv__fields');
    wrap.setAttribute('role', 'group');
    wrap.setAttribute('aria-label', 'Данни за фактура');
    root.appendChild(wrap);

    var inst = { root: root, check: check, wrap: wrap, fields: {} };

    FIELDS.forEach(function (f) {
      var row = el('div', 'kh-inv__row');
      var input = el('input', 'kh-inv__input');
      input.type = f.type;
      input.id = 'kh-inv-' + f.id + '-' + n;
      input.autocomplete = f.autocomplete;
      if (f.inputmode) { input.setAttribute('inputmode', f.inputmode); }
      if (f.id === 'eik') { input.maxLength = 13; }
      else { input.maxLength = 200; }
      if (f.required) { input.required = true; input.setAttribute('aria-required', 'true'); }
      var label = el('label', 'kh-inv__label', f.label);
      label.setAttribute('for', input.id);
      if (!f.required) {
        label.appendChild(document.createTextNode(' '));
        label.appendChild(el('span', 'kh-inv__opt', '(по желание)'));
      }
      var err = el('p', 'kh-inv__err');
      err.id = 'kh-inv-err-' + f.id + '-' + n;
      err.hidden = true;
      input.setAttribute('aria-describedby', err.id);
      row.appendChild(label);
      row.appendChild(input);
      row.appendChild(err);
      wrap.appendChild(row);
      inst.fields[f.id] = { input: input, err: err };

      input.addEventListener('input', function () {
        state.v[f.id] = input.value;
        showError(inst, f.id, '');
        syncAll(input);
        scheduleSave();
      });
      input.addEventListener('blur', function () {
        showError(inst, f.id, fieldError(f));
      });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); }
        e.stopPropagation();
      });
      input.addEventListener('keyup', function (e) { e.stopPropagation(); });
      input.addEventListener('keypress', function (e) { e.stopPropagation(); });
    });

    check.addEventListener('change', function () {
      state.on = check.checked;
      if (!state.on) {
        instances.forEach(function (i) {
          FIELDS.forEach(function (f) { showError(i, f.id, ''); });
        });
      }
      syncAll();
      scheduleSave();
      if (state.on) {
        var first = inst.fields.company.input;
        setTimeout(function () { try { first.focus(); } catch (e) {} }, 0);
      }
    });

    paint(inst);
    return inst;
  }

  function paint(inst, skipInput) {
    inst.check.checked = state.on;
    inst.wrap.hidden = !state.on;
    FIELDS.forEach(function (f) {
      var inp = inst.fields[f.id].input;
      if (inp === skipInput) { return; }
      if (inp.value !== state.v[f.id]) { inp.value = state.v[f.id]; }
    });
  }

  function syncAll(skipInput) {
    instances = instances.filter(function (i) { return i.root.isConnected; });
    instances.forEach(function (i) { paint(i, skipInput); });
  }

  /* ---------- mounting ---------- */

  function ensureStyle(host, doc) {
    if (host.querySelector('style[data-kh-invoice-css]')) { return; }
    var s = document.createElement('style');
    s.setAttribute('data-kh-invoice-css', '');
    s.textContent = CSS;
    (doc || host).appendChild(s);
  }

  function upcartRoot() {
    var r = window.upcartDocumentOrShadowRoot;
    if (r && typeof r.querySelector === 'function' && r !== document) { return r; }
    var h = document.getElementById('upCart');
    return h && h.shadowRoot ? h.shadowRoot : null;
  }

  function observeRoot(root) {
    if (!root || (observed && observed.has(root))) { return; }
    if (observed) { observed.add(root); }
    new MutationObserver(scheduleMount).observe(root, { childList: true, subtree: true });
  }

  function mountDrawer() {
    var sr = upcartRoot();
    if (!sr) { return; }
    observeRoot(sr);
    var items = sr.querySelector('ul.upcart-internal-cart-items');
    var existing = sr.querySelector('[data-kh-invoice]');
    if (!items || !items.parentNode) { return; }
    if (existing) { return; }
    ensureStyle(sr);
    var inst = build();
    items.parentNode.insertBefore(inst.root, items.nextSibling);
    instances.push(inst);
    refreshFromServer();
  }

  function mountPage() {
    var anchor = document.querySelector('.cart__form .cart__input-buttons');
    if (!anchor || !anchor.parentNode) { return; }
    if (document.querySelector('.cart__form [data-kh-invoice]')) { return; }
    ensureStyle(document.head);
    var inst = build();
    anchor.parentNode.insertBefore(inst.root, anchor);
    instances.push(inst);
    refreshFromServer();
  }

  var mountQueued = false;
  function scheduleMount() {
    if (mountQueued) { return; }
    mountQueued = true;
    var run = function () {
      mountQueued = false;
      try { mountDrawer(); mountPage(); } catch (e) {}
    };
    setTimeout(run, 16);
  }

  /* ---------- checkout guard ---------- */

  function onClickCapture(e) {
    if (bypass || !state.on) { return; }
    var path = typeof e.composedPath === 'function' ? e.composedPath() : [];
    var origin = path.length ? path[0] : e.target;
    if (!origin || typeof origin.closest !== 'function') { return; }
    var btn = origin.closest(CHECKOUT_SEL);
    if (!btn) { return; }

    var errs = allErrors();
    var ids = Object.keys(errs);
    if (ids.length) {
      e.preventDefault();
      e.stopImmediatePropagation();
      instances = instances.filter(function (i) { return i.root.isConnected; });
      instances.forEach(function (i) {
        FIELDS.forEach(function (f) { showError(i, f.id, errs[f.id] || ''); });
      });
      var vis = instances[0];
      if (vis) {
        try { vis.fields[ids[0]].input.focus(); vis.root.scrollIntoView({ block: 'center' }); } catch (x) {}
      }
      return;
    }
    if (dirty || saveTimer) {
      e.preventDefault();
      e.stopImmediatePropagation();
      flush().then(function () {
        bypass = true;
        try { btn.click(); } finally { bypass = false; }
      });
    }
  }

  document.addEventListener('click', onClickCapture, true);

  /* ---------- init ---------- */

  function init() {
    new MutationObserver(scheduleMount).observe(document.body, { childList: true, subtree: true });
    scheduleMount();
    // Upcart creates its shadow root lazily: poll until we are observing it.
    var tries = 0;
    var iv = setInterval(function () {
      tries += 1;
      scheduleMount();
      var r = upcartRoot();
      if ((r && observed && observed.has(r)) || tries > 240) { clearInterval(iv); }
    }, 500);
    ['upcartSubscribeCartOpened', 'upcartSubscribeCartLoaded', 'upcartSubscribeCartUpdated'].forEach(function (fn) {
      if (typeof window[fn] === 'function') { try { window[fn](scheduleMount); } catch (e) {} }
    });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
